<div class="student-modules-swipper-container relative">
    <swiper-container #swiperEl init="false" class="student-modules-swipper">
        <swiper-slide class="slide" *ngFor="let moduleUser of moduleUsers">
            <app-modules-card
                (clickedTag)="tagMultiSelectService.tagSelected($event, 'myModulesSelectedTags')"
                [module]="moduleUser.module"
                [finalGrade]="finalGrades[moduleUser.module.id]"
                [profile]="profile"
                [isCertificateOfAttendanceFeatureEnabled]="isCertificateOfAttendanceFeatureEnabled"
                [showPinModule]="false"
                [myModuleUser]="moduleUser"
            ></app-modules-card>
        </swiper-slide>
    </swiper-container>

    <div class="student-swiper-button-prev"></div>
    <div class="student-swiper-button-next"></div>
</div>
